import { useContext } from 'react';

import { AuthContext } from '../Context/index';

const useAuth = () => {
  const context = useContext(AuthContext);

  return context;
};

export default useAuth;
